
<template>
     <div class="weixin-tip" style="margin-top: 50px;">
        <div class="tip-img" style="display: flex;flex-direction: column;align-items: center">
            <img :src="require('/src/assets/img/arrow.png')" alt="微信打开" id="arrow">
            <p>点击右上角-选择在浏览器打开</p>
        </div>
        <div class="app-img" style="margin-top:40px ; display: flex;flex-direction: row;justify-content: center">
            <img :src="require('/src/assets/img/findpop.png')" id="logo">
        </div>
    </div>
</template>


<script>

</script>

<style  scoped>
#arrow{
    width: 100px;
    position: relative;
    left:30%;
   
}
#logo{
   
    width: 150px;
}
</style>

